module.exports = __webpack_public_path__ + "static/media/1029625.4ba76f8b.jpg";